/**
 * description:
 * Responsive grid of form/slide tiles. To add a new link, add an entry
 * (name + link) through the forms API — no new component needed.
 */
import { Box } from "@mui/material";
import FormComponent from "./FormComponent";

const FASAFormPage = ({ forms, cardColor, textColor, shadowColors }) => (
  <Box
    sx={{
      display: "grid",
      gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "repeat(3, 1fr)" },
      gap: "24px",
    }}
  >
    {forms.map((item, i) => (
      <FormComponent
        key={item.link ?? i}
        event={item.name}
        link={item.link}
        cardColor={cardColor}
        textColor={textColor}
        shadowColor={shadowColors[i % shadowColors.length]}
      />
    ))}
  </Box>
);

export default FASAFormPage;
